module.exports = __webpack_public_path__ + "static/media/home-bg.a4ef15cf.png";